export default __webpack_public_path__ + "static/media/Background_00138.748e1141.png";